import moment from "moment";
import { useLayoutEffect } from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  currencyFormatter,
  getCoverIdForExpiryDate,
  coverTypeLocation,
  inputValueType,
} from "../../store/businesslogic/hardwiredlogic";
import { getRowDetailsFromProspectId } from "../../store/myquotes";
import {
  getComparisonTable,
  getCoverTable,
  getCoverImportances,
  getCoverTableAsArray,
  getLocationAddresses,
  getCoverTypes,
  getResponseDetailsForCompareAsArray,
  getSTCoptions,
  updateSTCoptionComparisonTableValue,
  updateSTCoptionComparisonLocationValue,
  updateSTCOptionsToDB,
  getProspectDetails,
} from "../../store/quotes";
import { getFormState } from "../../store/qf";
import CoverTypeSelection from "./../CoverTypeSelection";
import SelectCoverByCoverType from "./SelectCoverByCoverType";
import { processCoversData } from "../../store/helperfuncs";
import _ from "lodash";

const InsurerCoverSelection = ({ prospectid, prospectDetails }) => {
  const dispatch = useDispatch();
  const [coverType, setCoverType] = useState("LIABILITY");
  const [coversOfCoverType, setCoversOfCoverType] = useState([]);
  const [coverIdBasedOnImportance, setCoverIdBasedOnImportance] = useState([]);
  const [selectedCovers, setSelectedCovers] = useState({});
  const [selectedLocationCovers, setSelectedLocationCovers] = useState({});
  const [hasDefualtDataBeenSet, setHasDefualtDataBeenSet] = useState(false);
  const [nodestate, setNodestate] = useState("");
  const [verticalId, setVerticalId] = useState();
  const insurers = useSelector(getResponseDetailsForCompareAsArray);
  const coverTypes = useSelector(getCoverTypes);
  const coverData = useSelector(getCoverTableAsArray);
  const covers = processCoversData(coverData);
  const coverImportance = useSelector(getCoverImportances);
  const comparisonTable = useSelector(getComparisonTable);
  const formState = useSelector(getFormState);
  const stcoptions = useSelector(getSTCoptions);
  const locations = useSelector(getLocationAddresses);
  const prospectLocations = locations?.state
    ? Object.keys(locations?.state).map((addressId) => ({
        id: addressId,
        ...locations?.state[addressId],
      }))
    : [];

  useEffect(() => {
    let locationObj = _.find(formState, (obj) => obj.type === "location");
    if (locationObj?.nodestate) {
      setNodestate(locationObj.nodestate);
    }
  }, [formState]);

  const coverTypesImportance = (verticalId) => {
    return coverImportance.map((item) => {
      if (
        item.importance >= 50 &&
        item.importance <= 10000 &&
        item.verticalid === prospectDetails?.calculatedverticalid
      ) {
        return item.coverid;
      }
    });
  };
  const conversToBeRemovedByImportance = coverImportance
    .filter(
      (it) =>
        it.importance === -1 &&
        it.verticalid === prospectDetails?.calculatedverticalid
    )
    .map((it) => it.coverid);

  // const processCovers = (coverTypeCode, addressId) =>
  // covers
  //   ?.filter((coverItem) => coverItem.covertypecode === coverTypeCode)
  //   .reduce((pv, cover, i) => {
  //     const shouldCheck = insurers.some(
  //       (insurer) => getCoverValue({ insurer, cover }, addressId) != "-"
  //     );
  //     if (shouldCheck && coverIdBasedOnImportance.includes(cover.id)) {
  //       pv[cover.id] = true;
  //     }
  //     return pv;
  //   }, {});

  useEffect(() => {
    const tempVerticalId = prospectDetails?.calculatedverticalid
      ? prospectDetails?.calculatedverticalid
      : prospectDetails?.selectedverticalid;

    setVerticalId(tempVerticalId);
    const coverIdsToWithoutNegetiveImp = [];

    setCoverIdBasedOnImportance(
      coverTypesImportance(tempVerticalId).filter(Boolean)
    );
    setCoversOfCoverType(
      covers?.filter((coverItem) => coverItem.covertypecode === coverType)
    );
  }, [coverType, prospectDetails]);

  useEffect(() => {
    // Cyber Security verticalID is 29. and it does not have GI(General Info) cover type that is default so I must update it to its cover type it does have at start
    if (verticalId && verticalId === 29) {
      setCoverType("RESPONSE");
    }
  }, verticalId);

  // below is all logic for locatons/building
  //first useeffect
  useEffect(() => {
    console.log("useEffect1", comparisonTable);
    console.log("useEffect1 covers", covers);
    if (
      !hasDefualtDataBeenSet &&
      (!comparisonTable ||
        Object.keys(comparisonTable).length === 0 ||
        (comparisonTable &&
          comparisonTable.otherCoverTypes &&
          comparisonTable.otherCoverTypes.length === 0))
    ) {
      const defaultCoverSelection = {};

      const processCovers = (coverTypeCode, addressId) =>
        covers
          ?.filter((coverItem) => coverItem.covertypecode === coverTypeCode)
          .reduce((pv, cover) => {
            const shouldCheck = insurers.some(
              (insurer) => getCoverValue({ insurer, cover }, addressId) != "-"
            );

            if (shouldCheck && coverIdBasedOnImportance.includes(cover.id)) {
              pv[cover.id] = true;
            }
            return pv;
          }, {});

      covers.map((cover, i) => {
        const shouldCheck = insurers.some(
          (insurer) => getCoverValue({ insurer, cover }) != "-"
        );
        if (shouldCheck && coverIdBasedOnImportance.includes(cover.id)) {
          defaultCoverSelection[cover.id] = true;
        }
      });

      // Default cover selection for locations
      const defaultLocationArray = prospectLocations.reduce(
        (pvLocation, { id: addressId }) => {
          const defaultCoverValues = processCovers(
            coverTypeLocation,
            addressId
          );

          pvLocation[addressId] = defaultCoverValues;

          // If buildings exist, process covers for each building
          const locationData = insurers?.[0]?.locations?.[addressId] ?? null;

          console.log("locationData", locationData);
          if (locationData && locationData.buildings) {
            Object.keys(locationData.buildings).forEach((buildingId) => {
              const buildingCovers = processCovers(
                coverTypeLocation,
                `${addressId}_building_${buildingId}`
              );
              console.log("buildingCovers", buildingCovers);
              pvLocation[`${addressId}_building_${buildingId}`] =
                buildingCovers;
            });
          }

          return pvLocation;
        },
        {}
      );
      // Update selected covers
      setSelectedCovers({
        location: defaultLocationArray,
        ...defaultCoverSelection,
      });

      // Update comparisons
      if (defaultCoverSelection) {
        let objectKeys = {};
        Object.keys(defaultLocationArray).forEach((addressId) => {
          const keyItemList = Object.keys(defaultLocationArray[addressId]).map(
            (coverId) => ({ key: coverId })
          );
          objectKeys[addressId] = keyItemList;
        });
        updateComparisons({
          otherCoverTypes: Object.keys(defaultCoverSelection)?.map(
            (coverId) => ({ key: coverId })
          ),
          locationCoverType: objectKeys,
        });
      }
    }
  }, [coverType, comparisonTable, coverIdBasedOnImportance]);

  //Second use effect
  useEffect(async () => {
    console.log("useEffect2", comparisonTable);
    if (
      !hasDefualtDataBeenSet &&
      (!comparisonTable ||
        Object.keys(comparisonTable).length === 0 ||
        (comparisonTable &&
          comparisonTable.otherCoverTypes &&
          comparisonTable.otherCoverTypes.length === 0))
    ) {
      const defaultCoverSelection = {};

      // Function to process covers for both locations and buildings
      const processCovers = (coverTypeCode, addressId) =>
        covers
          ?.filter((coverItem) => coverItem.covertypecode === coverTypeCode)
          .reduce((pv, cover) => {
            const shouldCheck = insurers.some(
              (insurer) => getCoverValue({ insurer, cover }, addressId) != "-"
            );
            if (shouldCheck && coverIdBasedOnImportance.includes(cover.id)) {
              pv[cover.id] = true;
            }
            return pv;
          }, {});

      covers.map((cover, i) => {
        const shouldCheck = insurers.some(
          (insurer) => getCoverValue({ insurer, cover }) != "-"
        );
        if (shouldCheck && coverIdBasedOnImportance.includes(cover.id)) {
          defaultCoverSelection[cover.id] = true;
        }
      });
      // if (!hasDefualtDataBeenSet) {
      // Default cover selection for locations and buildings
      const defaultLocationArray = prospectLocations.reduce(
        (pvLocation, { id: addressId }) => {
          const defaultCoverValues = processCovers(
            coverTypeLocation,
            addressId
          );
          pvLocation[addressId] = defaultCoverValues;

          // Process covers for each building if they exist
          const locationData = insurers?.[0]?.locations?.[addressId] ?? null;
          if (locationData && locationData.buildings) {
            Object.keys(locationData.buildings).forEach((buildingId) => {
              const buildingCovers = processCovers(
                coverTypeLocation,
                `${addressId}_building_${buildingId}`
              );
              pvLocation[`${addressId}_building_${buildingId}`] =
                buildingCovers;
            });
          }

          return pvLocation;
        },
        {}
      );

      // Update selected covers
      setSelectedCovers({
        location: defaultLocationArray,
        ...defaultCoverSelection,
      });

      // Update comparisons
      if (defaultCoverSelection) {
        let objectKeys = {};
        Object.keys(defaultLocationArray).forEach((addressId) => {
          const keyItemList = Object.keys(defaultLocationArray[addressId]).map(
            (coverId) => ({ key: coverId })
          );
          objectKeys[addressId] = keyItemList;
        });

        await updateComparisons({
          otherCoverTypes: Object.keys(defaultCoverSelection)?.map(
            (coverId) => ({ key: coverId })
          ),
          locationCoverType: objectKeys,
        });

        setHasDefualtDataBeenSet(true);
      }
    }
  }, [coversOfCoverType, comparisonTable, coverIdBasedOnImportance]);

  // don't remove below commented code becouse this code is set empty data while set first time loading.
  //third useEffect
  useEffect(async () => {
    console.log("useEffect3");
    console.log("insurer format", insurers);
    if (
      comparisonTable &&
      comparisonTable.otherCoverTypes &&
      comparisonTable.otherCoverTypes.length <= 0
    ) {
      var defaultCoverSelection = {};

      // Function to process covers for both locations and buildings
      const processCovers = (coverTypeCode, addressId) =>
        covers
          ?.filter((coverItem) => coverItem.covertypecode === coverTypeCode)
          .reduce((pv, cover) => {
            const shouldCheck = insurers.some(
              (insurer) => getCoverValue({ insurer, cover }, addressId) != "-"
            );
            if (shouldCheck && coverIdBasedOnImportance.includes(cover.id)) {
              pv[cover.id] = true;
            }
            return pv;
          }, {});

      covers.map((cover, i) => {
        const shouldCheck = insurers.some(
          (insurer) => getCoverValue({ insurer, cover }) != "-"
        );
        if (shouldCheck && coverIdBasedOnImportance.includes(cover.id)) {
          defaultCoverSelection[cover.id] = true;
        }
      });
      if (comparisonTable.otherCoverTypes) {
        //need to copy over older values to make sure they not erased between switch
        comparisonTable.otherCoverTypes.map((val) => {
          defaultCoverSelection[val.key] = true;
        });
      }

      // Default cover selection for locations and buildings
      const defaultLocationArray = prospectLocations.reduce(
        (pvLocation, { id: addressId }) => {
          const defaultCoverValues = processCovers(
            coverTypeLocation,
            addressId
          );
          pvLocation[addressId] = defaultCoverValues;

          // Process covers for each building if they exist
          const locationData = insurers?.[0]?.locations?.[addressId] ?? null;
          if (locationData && locationData.buildings) {
            Object.keys(locationData.buildings).forEach((buildingId) => {
              const buildingCovers = processCovers(
                coverTypeLocation,
                `${addressId}_building_${buildingId}`
              );
              pvLocation[`${addressId}_building_${buildingId}`] =
                buildingCovers;
            });
          }

          return pvLocation;
        },
        {}
      );

      // Update selected covers
      setSelectedCovers({
        location: defaultLocationArray,
        ...defaultCoverSelection,
      });

      // Update comparisons
      if (defaultCoverSelection) {
        let objectKeys = {};
        Object.keys(defaultLocationArray).forEach((addressId) => {
          const keyItemList = Object.keys(defaultLocationArray[addressId]).map(
            (coverId) => ({ key: coverId })
          );
          if (comparisonTable.locationCoverType) {
            objectKeys[addressId] = _.union(
              keyItemList,
              comparisonTable.locationCoverType[addressId]
            );
          } else {
            objectKeys[addressId] = keyItemList;
          }
        });
        await updateComparisons({
          otherCoverTypes: Object.keys(defaultCoverSelection)?.map(
            (coverId) => ({ key: coverId })
          ),
          locationCoverType: objectKeys,
        });
      }
    }
  }, [coverIdBasedOnImportance]);

  //fourth useEffect
  useEffect(() => {
    console.log("useEffect4", comparisonTable);
    const { locationCoverType, otherCoverTypes } = comparisonTable;
    let objectKeys = {};

    if (locationCoverType && prospectLocations.length > 0) {
      prospectLocations.forEach((location) => {
        let cov = [];
        const locationId = location.id;

        // Process location covers
        const keyItemList = locationCoverType[locationId]?.reduce((pv, cv) => {
          pv[cv.key] = true;
          return pv;
        }, {});

        objectKeys[locationId] = keyItemList;

        // Process building covers if they exist
        const locationData = insurers?.[0]?.locations?.[locationId] ?? null;
        if (locationData && locationData.buildings) {
          Object.keys(locationData.buildings).forEach((buildingId) => {
            let buildingCov = [];
            const buildingCoverId = `${locationId}_building_${buildingId}`;
            const buildingKeyItemList = locationCoverType[
              buildingCoverId
            ]?.reduce((pv, cv) => {
              pv[cv.key] = true;
              return pv;
            }, {});
            objectKeys[buildingCoverId] = buildingKeyItemList;
          });
        }
      });
    }

    if (Array.isArray(otherCoverTypes) && otherCoverTypes.length > 0) {
      setSelectedCovers({
        location: objectKeys,
        ...otherCoverTypes.reduce((pv, cv) => {
          pv[cv.key] = true;
          return pv;
        }, {}),
      });
    }
  }, [comparisonTable]);

  const getCoverValue = (
    {
      insurer: {
        covers: coversInhouse,
        coversasis: coversManual,
        locations: locationValue,
        source,
      },
      cover: { id: coverId, inputvaluetype: inputValue },
    },
    index
  ) => {
    // let covers =
    //   (locationValue && index >= 0 && locationValue[index]) ||
    //   coversManual ||
    //   coversInhouse;

    let covers;

    // Determine if the index is referring to a building
    const buildingMatch = /(\d+)_building_(\d+)/.exec(index);
    // console.log("let me see the match buildingMatch", buildingMatch);
    if (buildingMatch) {
      const [_, locationIndex, buildingIndex] = buildingMatch.map(Number);
      covers =
        locationValue &&
        locationValue[locationIndex] &&
        locationValue[locationIndex].buildings &&
        locationValue[locationIndex].buildings[buildingIndex];

      // console.log(
      //   "let me see the match buildingMatch locationValue[locationIndex].buildings[buildingIndex]",
      //   locationValue[locationIndex].buildings[buildingIndex]
      // );
    } else {
      covers =
        (locationValue && index >= 0 && locationValue[index]) ||
        coversInhouse ||
        coversManual;
    }

    let coverValue = (covers && covers[coverId]) || "-";
    if (
      coverType &&
      coverType === coverTypeLocation &&
      coverValue > 0 &&
      coverValue <= 1
    ) {
      coverValue = coverValue * 100 + "%";
    }

    if (coverId === getCoverIdForExpiryDate()) {
      coverValue = moment(new Date(coverValue)).format("DD MMM YYYY");
    } else if (
      isNaN(coverValue) ||
      (coverType && coverType === coverTypeLocation)
    ) {
      coverValue = coverValue ? `${coverValue}` : "-";
    } else {
      if (coverValue > 0 && coverValue <= 2) {
        coverValue = coverValue * 100 + "%";
      } else if (source == "manual" && inputValue === inputValueType) {
        coverValue = coverValue + "%";
      } else {
        coverValue = currencyFormatter.format(coverValue);
      }
    }

    return coverValue;
  };

  // const updateComparisons = async (comparisons) => {
  //   console.log("comparisonss", comparisons);
  //   dispatch(
  //     updateSTCoptionComparisonTableValue({
  //       key: "comparison",
  //       value: comparisons,
  //     })
  //   );
  //   if (comparisons?.otherCoverTypes?.length > 0) {
  //     await dispatch(updateSTCOptionsToDB({ prospectid, stcoptions }));
  //   }
  // };

  function hasNonEmptyLocationCoverType(data) {
    return _.some(data.locationCoverType, (array) => !_.isEmpty(array));
  }

  const updateComparisons = async (comparisons) => {
    const currentComparisons = comparisonTable; // Adjust to your state structure

    if (
      JSON.stringify(currentComparisons) !== JSON.stringify(comparisons) ||
      !hasDefualtDataBeenSet
    ) {
      if (
        hasNonEmptyLocationCoverType(comparisons) ||
        comparisons?.otherCoverTypes?.length > 0
      ) {
        await dispatch(
          updateSTCoptionComparisonTableValue({
            key: "comparison",
            value: comparisons,
          })
        );
      }
    }
  };
  // const handleChecked = (checked, coverId, location, building) => {
  //   const { locationCoverType, otherCoverTypes } = comparisonTable;
  //   let comparisons = [];

  //   console.log("lets handle it building", building);
  //   console.log("lets handle it locationCoverType", locationCoverType);
  //   console.log("lets handle it checked", checked);
  //   console.log("lets handle it coverId", coverId);

  //   console.log("locationCoverType", locationCoverType);
  //   if (location) {
  //     const locationId = location.id;
  //     const buildingKey = building
  //       ? `${locationId}_building_${building}`
  //       : null;
  //     comparisons = buildingKey
  //       ? [...(locationCoverType[buildingKey] || [])]
  //       : [...(locationCoverType[locationId] || [])];
  //     console.log("comparisons", comparisons);
  //     if (checked) {
  //       if (!comparisons.some((it) => it.key === coverId)) {
  //         comparisons.push({ key: coverId.toString() });
  //       }
  //     } else {
  //       comparisons = comparisons.filter((it) => it.key !== coverId);
  //     }

  //     const updatedLocationCoverType = buildingKey
  //       ? {
  //           // ...locationCoverType,
  //           location: {
  //             ...locationCoverType["location"],
  //             [buildingKey]: comparisons,
  //           },
  //         }
  //       : {
  //           ...locationCoverType,
  //           location: {
  //             ...locationCoverType["location"],
  //             [locationId]: comparisons,
  //           },
  //         };

  //     console.log(
  //       "lets handle it updatedLocationCoverType ",
  //       updatedLocationCoverType
  //     );

  //     updateComparisons({
  //       locationCoverType: updatedLocationCoverType,
  //       otherCoverTypes,
  //     });

  //     // Update selected covers for building or location
  //     const updatedSelectedCovers = { ...selectedCovers };
  //     if (buildingKey) {
  //       updatedSelectedCovers.location = {
  //         ...(updatedSelectedCovers.location || {}),
  //         [buildingKey]: {
  //           ...(updatedSelectedCovers.location?.[buildingKey] || {}),
  //           [coverId]: checked,
  //         },
  //       };
  //       console.log(
  //         "lets handle it updatedSelectedCovers ",
  //         updatedSelectedCovers
  //       );
  //     } else {
  //       updatedSelectedCovers.location = {
  //         ...(updatedSelectedCovers.location || {}),
  //         [locationId]: {
  //           ...(updatedSelectedCovers.location?.[locationId] || {}),
  //           [coverId]: checked,
  //         },
  //       };
  //     }
  //     setSelectedCovers(updatedSelectedCovers);
  //   } else {
  //     // Global cover selection logic
  //     comparisons = checked
  //       ? [...otherCoverTypes, { key: coverId.toString() }]
  //       : otherCoverTypes.filter((it) => it.key !== coverId);

  //     updateComparisons({
  //       locationCoverType,
  //       otherCoverTypes: comparisons,
  //     });

  //     setSelectedCovers({ ...selectedCovers, [coverId]: checked });
  //   }
  // };

  const handleChecked = (checked, coverId, location, building) => {
    const { locationCoverType, otherCoverTypes } = comparisonTable;
    let comparisons = [];
    // Building or Location specific logic
    if (location) {
      const locationId = building
        ? `${location.id}_building_${building}`
        : location.id;
      comparisons = [...(locationCoverType[locationId] || [])];
      if (checked) {
        if (!comparisons.some((it) => it.key === coverId)) {
          comparisons.push({ key: coverId.toString() });
        }
      } else {
        comparisons = comparisons.filter((it) => it.key !== coverId.toString());
      }
      const updatedLocationCoverType = {
        ...locationCoverType,
        [locationId]: comparisons,
      };

      updateComparisons({
        locationCoverType: updatedLocationCoverType,
        otherCoverTypes,
      });

      // Update selected covers for building or location
      const updatedSelectedCovers = { ...selectedCovers };

      if (building) {
        updatedSelectedCovers["location"][locationId] = {
          ...(updatedSelectedCovers["location"][locationId] || {}),
          [coverId]: checked,
        };

        // {
        //   ...(updatedSelectedCovers[locationId] || {}),
        //   [coverId]: checked,
        // };
        // updatedSelectedCovers[locationId] = {
        //   ...(updatedSelectedCovers[locationId] || {}),
        //   [coverId]: checked,
        // };
        // {
        //             ...locationCoverType,
        //             location: {
        //               ...locationCoverType["location"],
        //               [buildingKey]: comparisons,
        //             },
        //           }

        console.log(
          "lets handle it in building after updatedSelectedCovers ",
          updatedSelectedCovers
        );
      } else {
        updatedSelectedCovers.location = {
          ...(updatedSelectedCovers.location || {}),
          [location.id]: {
            ...updatedSelectedCovers.location?.[location.id],
            [coverId]: checked,
          },
        };
      }
      console.log("updatedSelectedCovers", updatedSelectedCovers);
      setSelectedCovers(updatedSelectedCovers);
    } else {
      // Global cover selection logic
      comparisons = checked
        ? [...otherCoverTypes, { key: coverId.toString() }]
        : otherCoverTypes.filter((it) => it.key !== coverId.toString());

      updateComparisons({
        locationCoverType,
        otherCoverTypes: comparisons,
      });

      setSelectedCovers({ ...selectedCovers, [coverId]: checked });
    }
  };

  return (
    <>
      <CoverTypeSelection
        prospectid={prospectid}
        onChange={(coverType) => setCoverType(coverType)}
        prospectDetails={prospectDetails}
      ></CoverTypeSelection>

      <SelectCoverByCoverType
        coverType={coverType}
        locations={prospectLocations}
        conversToBeRemovedByImportance={conversToBeRemovedByImportance}
        getCoverValue={getCoverValue}
        selectedCovers={selectedCovers}
        coversOfCoverType={coversOfCoverType}
        nodestate={nodestate}
        handleChecked={handleChecked}
      ></SelectCoverByCoverType>
    </>
  );
};

export default InsurerCoverSelection;
